import { QESButton, QESTextInput } from "../qes-standards";
import { FC } from "react";

interface ManageFilterSetRowProps {
  filterName: string;
  index: number;
  isMarkedForDeletion: boolean;
  newName: string;
  toggleFilterDeletion: (filterName: string) => void;
  updateFilterName: (oldName: string, newName: string) => void;
}

const ManageFilterSetRow: FC<ManageFilterSetRowProps> = ({
                                                           filterName,
                                                           index,
                                                           isMarkedForDeletion,
                                                           newName,
                                                           toggleFilterDeletion,
                                                           updateFilterName
                                                         }: ManageFilterSetRowProps) => {
  return (
    <div className="row mb-3">
      <QESTextInput
        value={newName !== undefined ? newName : filterName}
        descriptiveText={
          isMarkedForDeletion ?
            "This filter set will be deleted." :
            newName !== undefined && newName !== filterName && `Updated from: ${filterName}`
        }
        testId={`manage-filter-set-row__filter-name--${index}`}
        onChange={(e) => updateFilterName(filterName, e.target.value)}
        // readOnly={!isEditable}
        label="Saved Filter Name"
        hideLabel={true}
        containerClassName="col-4"
        disabled={isMarkedForDeletion}
        isValid={
          newName === undefined ||
          (newName !== "" && newName !== "default") ||
          isMarkedForDeletion
        }
        required={true}
        // technically this is wrong, but we want the immediate error state if someone types "default"
        // instead of them having to navigate off first. since a user can just click "submit" right away
        wasFocusedExternally={true}
      />
      <span className="col">
        {index >= 0 ? (
          <QESButton
            qesType={isMarkedForDeletion ? "secondary" : "secondary-danger"}
            qesTestId={`manage-filter-set-row__delete--${index}`}
            onClick={() => toggleFilterDeletion(filterName)}
            className="col-4"
          >
            {isMarkedForDeletion ? "Cancel Deletion" : "Delete"}
          </QESButton>
        ) : (
          <QESButton
            qesType="secondary"
            qesTestId={`manage-filter-set-row__cancel--${index}`}
            onClick={() => toggleFilterDeletion(filterName)}
            className="col-4"
          >
            Cancel
          </QESButton>
        )}
      </span>
    </div>
  );
}

export default ManageFilterSetRow;
